import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faComment, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Card, Form, Button, Table, InputGroup, Alert, Badge, Modal } from '@themesberg/react-bootstrap';
import { collection, query, getDocs, orderBy, limit, getDoc, doc, deleteDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../../config/firebase';

export default () => {
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState("");
  const [allMessages, setAllMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);

  useEffect(() => {
    loadAllMessages();

    // Gerçek zamanlı güncelleme için chatRooms collection'ını dinle (son 50)
    const chatRoomsQuery = query(
      collection(db, 'chatRooms'),
      orderBy('lastMessageAt', 'desc'),
      limit(50)
    );
    const unsubscribe = onSnapshot(chatRoomsQuery, (snapshot) => {
      // ChatRoom'lar değiştiğinde listeyi yeniden yükle
      loadAllMessages();
    }, (error) => {
      console.error('Error listening to chatRooms:', error);
    });

    return () => unsubscribe();
  }, []);

  const loadAllMessages = async () => {
    try {
      setLoading(true);
      setError(null);

      // Son 50 chatRoom'u al - performans için limit eklendi
      const chatRoomsQuery = query(
        collection(db, 'chatRooms'),
        orderBy('lastMessageAt', 'desc'),
        limit(50)
      );
      const chatRoomsSnapshot = await getDocs(chatRoomsQuery);

      console.log(`Total chatRooms found: ${chatRoomsSnapshot.docs.length}`);

      const conversations = await Promise.all(
        chatRoomsSnapshot.docs.map(async (roomDoc) => {
          const roomData = roomDoc.data();
          const participantUids = roomData.participantUids || [];


          if (participantUids.length !== 2) {
            if (participantUids.includes('B75SqFo2H0UNxvISe0X8YfFOLJ02')) {
              console.warn(`ChatRoom ${roomDoc.id} has ${participantUids.length} participants (expected 2):`, participantUids);
            }
            return null;
          }

          const participantsDocs = await Promise.all(
            participantUids.map((uid) => getDoc(doc(db, 'users', uid)))
          );
          const participantProfiles = participantUids.map((uid, index) => {
            const snap = participantsDocs[index];
            const data = snap.exists() ? snap.data() : {};
            // Fallback: use chatRoom-level sender/receiver name fields stored by admin panel
            const fallbackName = roomData.lastMessageSenderName || roomData.lastMessageReceiverName || null;
            return {
              id: uid,
              name: data.name || data.displayName || fallbackName || uid.substring(0, 8) + '...',
              avatar: data.profileImageUrl || data.photoUrl || null,
              isApproved: data.isApproved === true || data.isTestUser === true || data.isVerified === true
            };
          });

          // Identify Bot (verified) and Member (not verified)
          const botUser = participantProfiles.find(p => p.isApproved) || participantProfiles[0];
          const memberUser = participantProfiles.find(p => !p.isApproved) || participantProfiles[1] || participantProfiles[0];

          const participantMap = participantProfiles.reduce((acc, profile) => {
            acc[profile.id] = profile;
            return acc;
          }, {});

          const messagesRef = collection(db, 'chatRooms', roomDoc.id, 'messages');
          const messagesSnapshot = await getDocs(
            query(messagesRef, orderBy('timestamp', 'desc'), limit(1))
          );

          // Mesaj yoksa bile chatRoom'u göster (tüm mesajlar için)
          let lastMessage = null;
          let lastMessageDoc = null;
          let displayDate = new Date();

          if (!messagesSnapshot.empty) {
            lastMessageDoc = messagesSnapshot.docs[0];
            lastMessage = lastMessageDoc.data();
            const lastActivity = roomData.lastMessageAt || lastMessage.timestamp;
            displayDate = lastActivity?.toDate
              ? lastActivity.toDate()
              : lastMessage.timestamp?.toDate
                ? lastMessage.timestamp.toDate()
                : new Date();
          } else {
            // Mesaj yoksa chatRoom'un oluşturulma tarihini kullan
            displayDate = roomData.createdAt?.toDate
              ? roomData.createdAt.toDate()
              : roomData.lastMessageAt?.toDate
                ? roomData.lastMessageAt.toDate()
                : new Date();
          }


          return {
            id: lastMessageDoc?.id || roomDoc.id,
            roomId: roomDoc.id,
            bot: botUser,
            member: memberUser,
            participantMap,
            message: lastMessage ? (
              lastMessage.message || (
                lastMessage.type === 'image' ? '📷 Fotoğraf' :
                  lastMessage.type === 'video' ? '🎥 Video' :
                    lastMessage.type === 'audio' ? '🎤 Ses' : 'Mesaj'
              )
            ) : 'Henüz mesaj yok',
            timestamp: lastMessage?.timestamp || null,
            lastActivity: lastMessage?.timestamp || null,
            lastMessageSenderId: lastMessage?.senderId,
            type: lastMessage?.type || 'text',
            date: displayDate
          };
        })
      );

      const messagesList = conversations
        .filter(Boolean)
        .sort((a, b) => b.date.getTime() - a.date.getTime());

      setAllMessages(messagesList);
    } catch (err) {
      console.error('Error loading all messages:', err);
      setError('Mesajlar yüklenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  /*
   * ====================================================================
   * KRİTİK: ONAYLI PROFİL TESPİTİ
   * ====================================================================
   * 
   * Admin panelden HER ZAMAN onaylı profil adına mesaj atılmalıdır.
   * 
   * URL PARAMETRELERİNİN ANLAMI:
   * - receiverId = ONAYLI PROFİL (admin bu profil adına mesaj atar)
   * - senderId = GERÇEK KULLANICI (mesajı alan)
   * 
   * KURALLAR:
   * 1. Her iki kullanıcının verisini çek
   * 2. Onaylı olanı tespit et (isApproved === true veya benzer field)
   * 3. Onaylı profil → receiverId
   * 4. Diğer kullanıcı → senderId
   * 5. Hiçbiri onaylı değilse uyarı ver ve engelle
   * ====================================================================
   */

  const handleViewMessages = async (conversation, e) => {
    if (!conversation) return;

    try {
      // ✅ ONAYLI PROFİL TESPİTİ VE URL OLUŞTURMA
      // Not: conversation.bot ve conversation.member zaten loadAllMessages içinde yüklendi.
      const verifiedProfileId = conversation.bot.id;
      const realUserId = conversation.member.id;

      // ✅ URL oluştur: receiverId = ONAYLI PROFİL, senderId = GERÇEK KULLANICI
      const url = `/messages/reply/${conversation.roomId}?receiverId=${verifiedProfileId}&senderId=${realUserId}`;

      console.log('🔍 Onaylı profil tespiti:', {
        botName: conversation.bot.name,
        memberName: conversation.member.name,
        verifiedProfileId,
        realUserId,
        url
      });

      // Ctrl+Click veya Cmd+Click ile yeni sekmede aç
      if (e && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        window.open(url, '_blank');
        return;
      }

      // Normal tıklama - aynı sayfada aç
      history.push(url);
    } catch (err) {
      console.error('Error verifying profile:', err);
      setError('Kullanıcı bilgileri kontrol edilirken hata oluştu.');
    }
  };

  const handleDeleteConversation = async () => {
    if (!selectedConversation) return;
    try {
      setDeleteInProgress(true);
      const messagesRef = collection(db, 'chatRooms', selectedConversation.roomId, 'messages');
      const messagesSnapshot = await getDocs(messagesRef);
      await Promise.all(messagesSnapshot.docs.map((docSnap) => deleteDoc(docSnap.ref)));
      await deleteDoc(doc(db, 'chatRooms', selectedConversation.roomId));
      setAllMessages((prev) => prev.filter((msg) => msg.roomId !== selectedConversation.roomId));
      setShowDeleteConfirm(false);
      setSelectedConversation(null);
    } catch (err) {
      console.error('Error deleting conversation:', err);
      setError('Sohbet silinirken bir hata oluştu.');
    } finally {
      setDeleteInProgress(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return '-';
    const d = date instanceof Date ? date : date.toDate();
    // Türkiye saat dilimine göre göster (Europe/Istanbul)
    return d.toLocaleString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Istanbul'
    });
  };

  const formatMessageContent = (msg) => {
    if (!msg) return '';
    if (msg.type === 'image') return '📷 Fotoğraf gönderildi';
    if (msg.type === 'video') return '🎥 Video gönderildi';
    if (msg.type === 'audio') return '🎤 Ses kaydı gönderildi';
    return msg.message || 'Mesaj';
  };

  const filteredMessages = allMessages.filter(msg => {
    if (!searchTerm) return true;
    const search = searchTerm.toLowerCase();
    return msg.bot.name.toLowerCase().includes(search) ||
      msg.member.name.toLowerCase().includes(search) ||
      msg.message.toLowerCase().includes(search);
  });

  return (
    <>
      <div className="py-4">
        <div className="d-flex justify-content-between align-items-center">
          <h4>Tüm Mesajlar</h4>
          <Button variant="primary" onClick={loadAllMessages} disabled={loading}>
            <FontAwesomeIcon icon={loading ? faSpinner : faComment} className={loading ? "fa-spin" : ""} />
            <span className="ms-2">{loading ? 'Yükleniyor...' : 'Yenile'}</span>
          </Button>
        </div>
      </div>

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body>
          {error && (
            <Alert variant="danger" className="mb-4">
              {error}
            </Alert>
          )}

          <div className="mb-4">
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Gönderen, alıcı veya mesaj içeriğine göre ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Button variant="primary">Ara</Button>
            </InputGroup>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <FontAwesomeIcon icon={faSpinner} className="fa-spin fa-2x" />
              <p className="mt-3">Mesajlar yükleniyor...</p>
            </div>
          ) : filteredMessages.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-muted">Mesaj bulunamadı.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <Table className="table-dark table-hover mb-0" style={{ fontSize: '0.9rem' }}>
                <thead>
                  <tr>
                    <th style={{ width: '50px' }}>#</th>
                    <th style={{ width: '200px' }}>Gönderen Üye</th>
                    <th style={{ width: '200px' }}>Alıcı Üye</th>
                    <th>Son Mesaj</th>
                    <th style={{ width: '180px' }}>Son Etkinlik</th>
                    <th style={{ width: '150px' }}>İşlem</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMessages.map((msg, index) => (
                    <tr key={msg.id}>
                      <td className="text-center">{index + 1}</td>
                      <td>
                        <div className="d-flex flex-column align-items-center">
                          {msg.bot.avatar ? (
                            <img
                              src={msg.bot.avatar}
                              alt={msg.bot.name}
                              className="rounded-circle mb-1"
                              style={{ width: 50, height: 50, objectFit: 'cover' }}
                            />
                          ) : (
                            <div
                              className="rounded-circle bg-secondary mb-1 d-flex align-items-center justify-content-center text-white"
                              style={{ width: 50, height: 50 }}
                            >
                              {msg.bot.name.charAt(0).toUpperCase()}
                            </div>
                          )}
                          <small>{msg.bot.name}</small>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex flex-column align-items-center">
                          {msg.member.avatar ? (
                            <img
                              src={msg.member.avatar}
                              alt={msg.member.name}
                              className="rounded-circle mb-1"
                              style={{ width: 50, height: 50, objectFit: 'cover' }}
                            />
                          ) : (
                            <div
                              className="rounded-circle bg-secondary mb-1 d-flex align-items-center justify-content-center text-white"
                              style={{ width: 50, height: 50 }}
                            >
                              {msg.member.name.charAt(0).toUpperCase()}
                            </div>
                          )}
                          <small>{msg.member.name}</small>
                        </div>
                      </td>
                      <td className="align-middle">
                        <div className="d-flex align-items-center">
                          {msg.type === 'image' && <span className="me-2">📷</span>}
                          {msg.type === 'video' && <span className="me-2">🎥</span>}
                          {msg.type === 'audio' && <span className="me-2">🎤</span>}
                          <span>{msg.message.length > 90 ? msg.message.substring(0, 90) + '...' : msg.message}</span>
                        </div>
                      </td>
                      <td className="align-middle">{formatDate(msg.date)}</td>
                      <td className="align-middle">
                        <div className="d-flex flex-column gap-2">
                          <Button
                            variant="outline-light"
                            size="sm"
                            onClick={(e) => handleViewMessages(msg, e)}
                          >
                            <FontAwesomeIcon icon={faEye} className="me-1" />
                            Mesajları Gör
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => {
                              setSelectedConversation(msg);
                              setShowDeleteConfirm(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faTrash} className="me-1" />
                            Sohbeti Sil
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}

          {!loading && filteredMessages.length > 0 && (
            <div className="mt-3">
              <Badge bg="info">Toplam {filteredMessages.length} mesaj konuşması</Badge>
            </div>
          )}
        </Card.Body>
      </Card>

      {/* Silme Onayı */}
      <Modal show={showDeleteConfirm} onHide={() => setShowDeleteConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Sohbeti Sil</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Bu sohbeti kalıcı olarak silmek istediğinize emin misiniz? İşlem geri alınamaz ve uygulama tarafında da sohbet kaldırılır.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteConfirm(false)} disabled={deleteInProgress}>
            İptal
          </Button>
          <Button variant="danger" onClick={handleDeleteConversation} disabled={deleteInProgress}>
            {deleteInProgress ? 'Siliniyor...' : 'Sil'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

